import { get, post } from '@/utils/service';
import { obj2string } from '@/utils/url';
import { i18n } from '@/locales/i18n';

export const commonapi = {
    // 获取kline数据
    getKlineData(params, config) {
        return get('@spot/api/quote/v2/klines', { params, ...config });
    },
    // 获取币种介绍
    getCurrencyInfo(params) {
        return get('@spot/api/token/get/detail', {
            params,
            headers: {
                'Accept-Language': i18n.global.locale.value,
            },
        });
    },
    // 获取系统（utc）时间戳
    getUtcTs() {
        return get('@spot/api/activity/v1/project/system/date');
    },

    getNoticeInfoBySymbolId(params) {
        return get('@spot/api/basic/query_notice_visible_symbol', { params });
    },

    getSuspensionInfoBySymbolId(params) {
        return get('@spot/api/basic/query_suspension_visible_symbol', { params });
    },

    // 法币充值、提币支持判断
    getFiatOperate(params) {
        return get('@spot/api/asset/user_is_sustain_real_money', { params });
    },

    // 获取当前行情
    getTradeTicker(params) {
        return get('@spot/api/quote/v1/ticker', { params });
    },
    // 获取热门币对运营位
    getHotSymbols(params) {
        return get('@spot/api/basic/hot_symbols', { params });
    },

    // 获取币对在特定KYC国家可用
    getSymbolKyc(params) {
        return get('@spot/api/basic/isKycRule', { params });
    },
};

// launchpad 活动接口
export const lpapi = {
    // 获取首页信息接口
    getIndexInfo() {
        return get('@spot/api/activity/v2/home');
    },
    // 获取订单列表
    getOrdersList(params) {
        return get('@spot/api/activity/v2/orders', { params });
    },
    // 获取活动列表
    getProjectList() {
        return get('@spot/api/activity/v2/project/list');
    },
    // 获取活动项目详情
    getProjectDetail(params) {
        return get('@spot/api/activity/v1/project/detail', { params });
    },
    // 获取活动资格
    getQualification(params, headers) {
        return get('@spot/api/activity/v1/qualifications/query', { params, headers });
    },
    // 获取活动结果
    getProjectResult(params) {
        return get('@spot/api/activity/v1/result/query', { params });
    },
    // 未登录获取活动结果
    getProjectUnregisteredResult(params) {
        return get('@spot/api/activity/v1/calculation/query', { params });
    },
    // 参加活动
    joinActive(params) {
        return get('@spot/api/activity/v2/pledge', { params });
    },
    // 获取资产持仓日历列表
    getBalancesCalendarV2(params) {
        return get('@spot/api/activity/v2/snapshot/calendar', { params });
    },
    // 获取下一期活动
    getNextProject() {
        return get('@spot/api/activity/v2/home/futures');
    },
    // 获取历史活动列表
    getHistoryProjects() {
        return get('@spot/api/activity/v2/home/history');
    },
    // 双池接口
    // 获取项目配置详情
    getProjectEventDetail(params) {
        return get('@spot/api/activity/v2/project/event/details', { params });
    },
    // 获取活动详情
    getProjectDetailV2(params) {
        return get('@spot/api/activity/v2/project/detail', { params });
    },
    // 获取活动资格
    getQualificationV2(params) {
        return get('@spot/api/activity/v2/qualifications/query', { params });
    },
    // 获取活动结果
    getProjectResultV2(params) {
        return get('@spot/api/activity/v2/result/query', { params });
    },
    // 获取币种数据
    getCurrencyList() {
        return get('@spot/api/activity/v2/currencyList');
    },
    // 获取邀请奖励记录
    getRewardsList(params) {
        return get('@spot/api/activity/v2/rewardList', { params });
    },
    // 获取用户中心整体数据
    getUserCenterInfo() {
        return get('@spot/api/activity/v2/userCenterInfo');
    },
    // 轮播图banner
    getBannerData() {
        return get('@spot/api/activity/v2/launchpoolBannerList');
    },
    // 获取用户同脸信息
    getDuplicateUserIds(params) {
        return get('@spot/api/activity/v2/getDuplicateUserIds', { params });
    },
    // 报名
    signup(params) {
        return get('@spot/api/v1/landingpage/signup', { params });
    },
    // 获取小时持仓日历
    getBalancesCalendarHour(params) {
        return get('@spot/api/activity/v2/snapshot/hour', { params });
    },
    getOnGoingList() {
        return get('@spot/api/activity/v2/project/ongoing/list');
    },
    getEndList(params) {
        return get('@spot/api/activity/v2/project/finished/list', { params });
    },
};

export const userapi = {
    getAsset(params) {
        return get('@spot/api/asset/get', { params });
    },
    getAssetAvailable(params) {
        return get('@spot/api/v1/asset/get_available', { params });
    },
    orderCreate(data, headers) {
        return post('@spot/api/order/create', obj2string(data), { headers });
    },
    createPlanOrder(data, headers) {
        return post('@spot/api/order/plan_spot/create', obj2string(data), { headers });
    },
    getOpenOrders(params) {
        return get('@spot/api/order/open_orders', { params });
    },
    getOpenPlanOrders(params) {
        return get('@spot/api/order/plan_spot/open_orders', { params });
    },
    getTradeOrders(params) {
        return get('@spot/api/order/trade_orders_v2', { params });
    },
    getTradePlanOrders(params) {
        return get('@spot/api/order/plan_spot/trade_orders', { params });
    },

    getMatchInfo(params) {
        return get('@spot/api/order/match_info', { params });
    },

    getPlanMatchInfo(params) {
        return post('@spot/api/order/plan_spot/get_v2', obj2string(params));
    },

    getMyTrades(params) {
        return get('@spot/api/order/my_trades', { params });
    },
    cancelPlanOrder(param, headers) {
        return post('@spot/api/order/plan_spot/cancel', obj2string(param), { headers });
    },
    cancelOrder(param, headers) {
        return post('@spot/api/order/cancel', obj2string(param), { headers });
    },
    cancelAllOrder(param, headers) {
        return post('@spot/api/order/batch_cancel', obj2string(param), { headers });
    },
    cancelAllPlanOrder(param, headers) {
        return post('@spot/api/order/plan_spot/batch_cancel', obj2string(param), { headers });
    },

    // 获取用户是否知晓BIT的免责声明
    getBitDisclaimer(params) {
        return get('@spot/s_api/user/trade_hint', { params });
    },
    // 设置用户知晓BIT免责声明状态
    setBitDisclaimer(param) {
        return post('@spot/s_api/user/trade_hint', obj2string(param));
    },
    // 获取创新区额度
    getInnovateQuota() {
        return get('@spot/api/basic/innovation/remain_amount');
    },

    // 提交签署的协议标签，作为公共接口，2023.4.17先由 SUI交易对协议需求接入；
    setMemberTag(param) {
        return post('@spot/api/account/set_member_tag', obj2string(param));
    },
    // 获取用户账户余额
    getBalanceV3() {
        return get('@api2/v3/private/cht/asset-show/launchpad-caliber-balance');
    },
};

// 场外借贷
export const otcLending = {
    // 借款申请
    submitLoanApply(data) {
        return post('@api2/spot/api/marginserver/v2/online/loanApply/add', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 查询借贷产品列表
    getProductList(params) {
        return get('@api2/spot/api/marginserver/v2/online/product/list', { params });
    },
    /**
     * 查询借贷产品记录列表
     *
     * @param {Object} data 参数
     * @param {string} data.status 状态，默认：1
     * @param {timestamp} data.gmtStasrtTime 开始时间
     * @param {timestamp} data.gmtEndTime 结束时间
     *
     * */
    getLoanList(data) {
        return post('@api2/spot/api/marginserver/v2/online/loanRecord/list', data);
    },
};

// 交易大赛接口
export const contestApi = {
    join(data) {
        return post('@spot/api/v1/contest/trading/join', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    getSignInStatus(params) {
        return get('@spot/api/v1/contest/trading/join/status', { params });
    },
    getRankList(params) {
        return get('@spot/api/v1/contest/trading/top/list', { params });
    },
    getMyRank(params) {
        return get('@spot/api/v1/contest/trading/top', { params });
    },
    getRules(params) {
        return get('@spot/api/v1/contest/trading/rule', { params });
    },
    getResult(params) {
        return get('@spot/api/v1/contest/trading/top/result', { params });
    },
    getCustomer(params) {
        return get('@spot/api/v1/contest/trading/customer', { params });
    },
};

// LT接口
export const ltApi = {
    /* 出于合规化考虑，ETP全部替换为LT（leveraged tokens） */
    // 获取 LT 风控状态
    getLtRiskStatus(params) {
        return get('@spot/api/lt/v2/tips/info', { params });
    },
    // 获取 LT 问卷答题
    getLtQuestion(params) {
        return get('@spot/api/lt/v1/tips/questionnaires', { params });
    },
    // 开通LT / 提交 LT 问卷答题
    submitLtQuestion(params) {
        return post('@spot/api/lt/v1/tips/submit', obj2string(params));
    },
    // 获取 LT 交易对调仓历史
    getRebalanceHistory(params) {
        return get('@spot/api/lt/v1/rebalance-history', { params });
    },
    // 查询 LT 交易对披露信息
    getLtSymbolInfo(params) {
        return get('@spot/api/lt/v1/info', { params });
    },
    // 申购
    getLtPurchase(params) {
        return post('@spot/api/lt/v1/purchase', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 赎回
    getLtRedeem(params) {
        return post('@spot/api/lt/v1/redeem', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 申购赎回记录
    getLtHistoryRecord(params) {
        return get('@spot/api/lt/v1/record', { params });
    },
    // 获取教学视频信息
    getLtLearningVideo(params) {
        return get('@spot/api/lt/v1/learning-video', {
            params,
            headers: {
                'Accept-Language': i18n.global.locale.value,
            },
        });
    },
    // 获取lt 代币的净值等信息
    getLtAssetValue(params) {
        return get('@spot/api/quote/v1/lt', {
            params,
        });
    },
};

// 全仓杠杆API
export const leverageApi = {
    // 全仓杠杆 开通、开启状态
    getRiskStatus(params) {
        return get('@spot/api/crossmargin/v1/tips/info', { params });
    },
    // 问卷答题
    getQuestion(params) {
        return get('@spot/api/crossmargin/v1/tips/questionnaires', { params });
    },
    // 开通、开启 提交问卷答题
    submitQuestion(params) {
        return post('@spotJson/api/crossmargin/v1/tips/submit', params);
    },
    // 查询借贷币种列表
    getTokenList(params) {
        return get('@spot/api/crossmargin/v1/token/list', { params });
    },
    // 获取账户可用总额
    getTotalAvailable(params) {
        return get('@spot/api/v1/asset/cross_margin/get_balance', { params });
    },
    // 一键借贷下单 限价/市价
    orderCreate(params) {
        return post('@spot/api/order/cross/create_order', obj2string(params));
    },
    // 查询账户风险率
    getRiskInfo(params) {
        return get('@spot/api/crossmargin/v1/risk/info', { params });
    },
    // 查询借款记录
    getLoanRecord(params) {
        return get('@spot/api/crossmargin/v1/loan/records', { params });
    },
    // 查询还款记录
    getRepayRecord(params) {
        return get('@spot/api/crossmargin/v1/repay/records', { params });
    },
    // 查询还款明细
    getRepayDetail(params) {
        return get('@spot/api/crossmargin/v1/repay/detail', { params });
    },
    // vip数据
    getVIPInfo(params) {
        return get('@spot/api/crossmargin/v1/vip/info/list', { params });
    },
    // 欠款币种 - 不传page和limit，默认返回500条
    getLoanBalance(params) {
        return get('@spot/api/crossmargin/v1/loan/balance', { params });
    },
    // 币种还款
    postCoinRepay(params) {
        return post('@spot/api/crossmargin/v1/forcerepay/apply', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 获取折扣率
    getDiscount() {
        return get('@spot/api/crossmargin/v1/margin/tokens');
    },
};

// 投票上币活动接口
export const voteapi = {
    // 获取系统时间
    getSystemTime() {
        return get('@spot/api/vote/v1/system/time');
    },
    // 获取首页活动信息
    getHomeVote() {
        return get('@spot/api/vote/v1/home');
    },
    // 获取首页历史成功项目
    getHomeWinnerList(params) {
        return get('@spot/api/vote/v1/winner/list', { params });
    },
    // 获取首页历史成功项目
    getHistoryWinner(params) {
        return get('@spot/api/vote/v1/historyWinner', { params });
    },
    /**
     * 获取项目详情
     *
     * @param {Object} params 参数
     * params.projectCode 项目code 必传
     * */
    getDetail(params) {
        return get('@spot/api/vote/v1/detail', { params });
    },
    /**
     * 获取投票记录
     *
     * @param {Object} params 参数
     * @param {string} params.currency 币种名称
     * @param {timestamp} params.startTime 开始时间
     * @param {timestamp} params.endTime 结束时间
     * @param {number} params.result 0:all,1:completed,2:failure,3:determined
     *
     * */
    getRecord(params) {
        return get('@spot/api/vote/v1/record', { params });
    },
    // 用户票数分配说明接口
    getInstructions(params) {
        return get('@spot/api/vote/v1/assignment/instructions', { params });
    },
    // 获取用户票数信息接口
    getUserVotes(params) {
        return get('@spot/api/vote/v1/user/votes', { params });
    },
    // 投票接口
    // projectCode 项目code 必传
    // voteNum 投票数 必传
    // useKycCoupon 是否使用KYC券  0:不使用 1:使用 默认值 0
    postUserVote(data) {
        return post('@spot/api/vote/v1/user/vote', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 获取投票上限数
    getVoteLimit(params) {
        return get('@spot/api/vote/v1/projectVoteLimit', { params });
    },
    // 获取用户额外信息（风控状态）
    getVoteUserRiskInfo() {
        return get('@spot/api/vote/v1/user/extraInfo');
    },
    // 用户是否为黑名单
    getUserIsBlackList() {
        return get('@spot/api/vote/v1/user/isBlacklist');
    },
    // 用户中心-My Current Votes
    getUserCurrentVotes() {
        return get('@spot/api/vote/v1/user/currentVotes');
    },
    // 用户中心-My Votes History (byvote 2.0)
    getUserVotesHistory(params) {
        return get('@spot/api/vote/v1/user/votesHistory', { params });
    },
    // 用户中心-My Votes History (byvote 2.0)
    getUserWinningHistory(params) {
        return get('@spot/api/vote/v1/user/winningHistory', { params });
    },
    getAdvertising() {
        return get('@spot/api/vote/v1/advertising', {});
    },
};

// bybit index 数据大盘
export const biapi = {
    // 获取市值前20币种排行榜
    getMarketCapTop() {
        return get('@spot/api/v1/index/top20');
    },
    // 版块市值前3币种信息
    getCategoryInfoDetail(params) {
        return get('@spot/api/v1/index/category', { params });
    },
};

// 质押借贷
export const loanApi = {
    // 用户信息
    getUserInfo(params) {
        return get('@spot/api/pledgeloan/v1/user/query', { params });
    },
    // 借贷币种列表
    getLoanTokens(params) {
        return get('@spot/api/pledgeloan/v1/loantoken/list', { params });
    },
    // 质押币种列表
    getPledgeTokens(params) {
        return get('@spot/api/pledgeloan/v1/pledgetoken/list', { params });
    },
    // 限额范围
    getTokenRange(params) {
        return get('@spot/api/pledgeloan/v1/tokenrange/info', { params });
    },
    // 逾期数据
    getOverdueInfo(params) {
        return get('@spot/api/pledgeloan/v1/overdueparameter/list', { params });
    },
    // 借贷-准入校验
    postCheckUser(data) {
        return post('@spot/api/pledgeloan/v1/user/admit', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 借贷申请提交
    postConfirmLoan(data) {
        return post('@spot/api/pledgeloan/v1/loanorder/submit', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 借贷结果/列表查询
    getLoanOrderList(params) {
        return get('@spot/api/pledgeloan/v1/loanorder/query', { params });
    },
    // 还款申请提交
    postConfirmRepay(data) {
        return post('@spot/api/pledgeloan/v1/repay/submit', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 还款结果/列表查询
    getRepayResult(params) {
        return get('@spot/api/pledgeloan/v1/repay/query', { params });
    },
    // 质押金调整申请提交
    postConfirmPledge(data) {
        return post('@spot/api/pledgeloan/v1/pledgefundchange/submit', data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 质押金调整结果/列表查询
    getPledgeResult(params) {
        return get('@spot/api/pledgeloan/v1/pledgefundchange/query', { params });
    },
    // 负债资产列表
    getAssetsDebt(params) {
        return get('@spot/api/pledgeloan/v1/asset/list', { params });
    },
    // 获取币种可用资产(只用于质押借贷业务)
    getTransferAsset(params) {
        return get('@spot/api/pledgeloan/v1/availablebalance/query', { params });
    },
    // 使用视频教程
    getUseVideo(params) {
        return get('@spot/api/pledgeloan/v1/learning-video/query', { params });
    },
};

// 盈亏分析详情
export const paapi = {
    // 获取用户资产，实时盈亏和累积盈亏
    getRealTimeProfitDetail(params) {
        return get('@spot/api/assetProfit/realTimeProfitDetail', { params });
    },
    // 获取用户收益列表（按日）包含累积收益率 ，累积收益，每日收益，资产列表
    getCumulativeReturnRateList(params) {
        return get('@spot/api/assetProfit/cumulativeReturnRateList', { params });
    },
    // 获取用户资产分布
    getAssetDistribution(params) {
        return get('@spot/api/assetProfit/assetDistribution', { params });
    },
};

// 网格交易
export const botApi = {
    // 获取用户资产分布
    getGridList(params) {
        return post('@bot/query-grid-list', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    getGridCloseModes(params) {
        return post('@bot/get-close-modes', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    closeGrid(params) {
        return post('@bot/close-grid', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 获取资金账户资产
    getFundsAsset(data) {
        return post('@bot/query-available-balance', data);
    },
    // 验证创建参数并获取ai数据
    validate(data) {
        return post('@api2/grid/v1/validate-input', data);
    },
    // 获取购买baseToken数量
    getBaseTokenAmount(data) {
        return post('@bot/get-initial-buy-amount', data);
    },
    // 创建网格
    createGrid(data) {
        return post('@bot/create-grid', data);
    },
};
